import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';
import { Button } from 'src/lib/components/Button';
import { Link } from 'src/lib/components/Link';
import Container from '../components/Container';
import { MagicLinkForm } from './MagicLinkForm';
import { MagicLinkSent } from './MagicLinkSent';

interface Props {
    initialUsername: string;
}

export const InvalidMagicLink = ({ initialUsername }: Props) => {
    const { t } = useTranslation('auth.magicLink');
    const [requestMagicLink, setRequestMagicLink] = useState<boolean>(true);

    if (!requestMagicLink) {
        return <MagicLinkSent onRequestMagicLink={setRequestMagicLink} />;
    }

    return (
        <Container width={360}>
            <Typography variant="h2" textAlign="center" marginBottom={2}>
                {t('expiredLoginLink')}
            </Typography>
            <Typography variant="body1" textAlign="center" marginBottom={4}>
                {t('requestReplacementLoginLink')}
            </Typography>
            <MagicLinkForm
                path={''}
                onRequestMagicLink={setRequestMagicLink}
                initialUsername={initialUsername}
            />
            <Box marginBottom={2}>
                <RouterLink to="/login">
                    <Button kind="outlined" color="primary" fullWidth>
                        {t('returnToLogin')}
                    </Button>
                </RouterLink>
            </Box>
            <Typography variant="body3" textAlign="center">
                <Link to="/sso">{t('loginWithSSO')}</Link>
            </Typography>
        </Container>
    );
};
